import { CommonModule } from '@angular/common';
import { Component, computed, input, Input } from '@angular/core';

import { TagModule } from 'primeng/tag';
import { SeverityClassEnum } from '../../common/severity-class.enum';

@Component({
    selector: 'app-tag',
    imports: [CommonModule, TagModule],
    templateUrl: './tag.component.html'
})
export class TagComponent {
  // Core Content Properties
  @Input() public content: string = '';
  @Input() public displayContent: boolean = true;
  @Input() public emptyContentPlaceholder: string = 'N/A';

  // Styling Related Properties
  @Input() public textColor: string = '';
  @Input() public backgroundColor: string = '';
  @Input() public borderColor: string = '';
  @Input() public tagInnerPadding: string = '';
  @Input() public customClass?: string;
  @Input() public customStyleClass?: string;
  fullWidth = input<boolean>();

  // Icon and Shape Properties
  @Input() public iconEnd: string = '';
  @Input() public iconStart: string = '';
  @Input() public roundedCorners: boolean = false;

  // custom severity and style classes to hanlde the design system options
  @Input() public severityClass:
    | keyof typeof SeverityClassEnum
    | SeverityClassEnum = 'info';

  @Input() public styleClass: 'light' | 'bold' = 'light';
  @Input() public sizeClass: 'tag-sm' | 'tag-md' = 'tag-md';

  widthClass = computed(() => (this.fullWidth() ? 'w-full' : ''));
}
